import React from "react";
import { useFormikContext } from "formik";
import { FormTextInput, FormSelect } from "@jsq/ds/forms";
import {
  CustomFieldType,
  CreateCustomFieldInput,
  FIELD_TYPE_OPTIONS,
  Section,
} from "../../types";
import FieldOptionsEditor from "../FieldOptionsEditor";
import SectionSelector from "../SectionSelector";
import * as styles from "../styles_vanilla.css";

interface Props {
  isEditMode?: boolean;
  sections?: Section[] | null;
}

const ModalBodyContent: React.FC<Props> = ({ isEditMode = false, sections = null }) => {
  const { values } = useFormikContext<CreateCustomFieldInput>();
  const isEnumerationType = values.type === CustomFieldType.ENUMERATION;

  return (
    <div className={isEnumerationType ? styles.scrollableModalBody : undefined}>
      <div className={styles.formGrid}>
        <FormTextInput
          name="name"
          label="Field name"
          placeholder="Enter a unique field name (e.g., company_size)"
          isFullWidth
          data-testid="field-name-input"
        />

        <FormSelect
          name="type"
          label="Field type"
          placeholder="Select field type"
          disabled={isEditMode}
          data-testid="field-type-select"
        >
          <FormSelect.Section>
            {FIELD_TYPE_OPTIONS.map((option) => (
              <FormSelect.Option key={option.value} value={option.value}>
                {option.label}
              </FormSelect.Option>
            ))}
          </FormSelect.Section>
        </FormSelect>

        <SectionSelector
          name="sectionId"
          label="Section"
          placeholder="Select a section (optional)"
          sections={sections}
          data-testid="field-section-select"
        />

        {values.type === CustomFieldType.ENUMERATION && (
          <FieldOptionsEditor
            name="options"
            label="Field options"
            helpText={
              isEditMode
                ? "Edit options of your enumeration field"
                : "Enter the display labels for your enumeration options"
            }
          />
        )}
      </div>
    </div>
  );
};

export default ModalBodyContent;
